import { legacy_createStore as createStore, combineReducers, applyMiddleware, compose } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { thunk } from 'redux-thunk';

//models
import staysReducer from './ducks/models/stays';
import clientReducer from './ducks/models/client';
import reportsReducer from './ducks/models/reports';
import rules from './ducks/models/rules';
import refill from './ducks/models/refill';
import processing from './ducks/models/processing';
import using from './ducks/models/using';
import working from './ducks/models/working';

//interface
import staysGridReducer from './ducks/interface/staysGrid';
import clientsCardReducer from './ducks/interface/clientsCard';
import refillGrid from './ducks/interface/refillGrid';
import usingReducer from './ducks/interface/usingGrid';
import workingReducer from './ducks/interface/workingGrid';

//widget
import widgetPopupReducer from './ducks/interface/widgetPopup';

const reducers = combineReducers({
  //model
  stays: staysReducer,
  client: clientReducer,
  reports: reportsReducer,
  rules: rules,
  refill: refill,
  processing: processing,
  using: using,
  working: working,

  //interface
  staysGrid: staysGridReducer,
  clientsCard: clientsCardReducer,
  refillGrid: refillGrid,
  usingGrid: usingReducer,
  workingGrid: workingReducer,

  //other
  widgetPopup: widgetPopupReducer,
  form: formReducer,
});

const composeEnhancers = typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({}) : compose;
const enhancer = composeEnhancers(applyMiddleware(thunk));
// const store = createStore(reducers, applyMiddleware(thunk));
const store = createStore(reducers, enhancer);

export default store;
